import { render, staticRenderFns } from "./SchoolYear.vue?vue&type=template&id=2356f7d9&"
import script from "./SchoolYear.vue?vue&type=script&lang=js&"
export * from "./SchoolYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports